// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"604107be","253":"f3e78696","723":"af04028a","927":"d68e0070"}[chunkId] + ".css";
};